import React, { useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Typography, Box, } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { fetchParticipantBiometrics } from '../../../reducers/admincenter_biometrics';
import { selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import { fetchParticipantResponses } from '../../../reducers/admincenter_responses';
import ResponsiveRectangle from '../skeletons/ResponsiveRectangle';


const ParticipantBiometrics = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))
    const { user: currentUser } = useSelector((state) => state.auth);

    const biometricStatus = useSelector(state => state.participantbiometrics.status)
    const responseStatus = useSelector(state => state.participantresponses.status)

    useEffect(() => {
        if (biometricStatus === "idle") {
            dispatch(fetchParticipantBiometrics({ authToken: currentUser.AuthToken, ParticipantGuid: Participant.ParticipantGuid }))
        }
        if (responseStatus === "idle") {
            dispatch(fetchParticipantResponses({ authToken: currentUser.AuthToken, ParticipantGuid: Participant.ParticipantGuid }))

        }
    }, [biometricStatus, responseStatus, dispatch])

    const handleCancel = () => {
        props.cancelButton()
    }

    const InitialScreen = () => {

        return (
            <Box>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5" align="center" gutterBottom>ENTER BIOMETRICS</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" align="center" gutterBottom>Would you like to upload these biometrics to an existing HRA or save for a future HRA?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container direction="row" alignItems="center" justifyContent="center">
                            <Grid item xs={12} md={4}>
                                <Box display="flex">
                                    <Button color="success">Add to existing HRA</Button>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box display="flex">
                                    <Button color="success">Save for future HRA</Button>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box display="flex">
                                    <Button color="error" onClick={() => { handleCancel() }}>Cancel</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        )
    }

    return (
        <Box>
            {
                biometricStatus === "success"
                    && responseStatus === "success"
                    ? (
                        <InitialScreen />
                    ) : (
                        <ResponsiveRectangle height="40" />
                    )
            }
        </Box>
    )
}

export default ParticipantBiometrics